import { Dates } from "../util/dates";
import { Users } from "../util/user.util";

export class User {
  id: string;
  name: string;
  email: string;
  jobTitle: string;
  authId: string;
  birthDate: Date;
  joinDate: Date;
  gender: string;
  companyId: string;
  accountId: string;
  state: string;
  createdBy: string;
  created: Date;
  modifiedBy: string;
  modified: Date;
  company: any;
  photo: string;
  phoneNumber: string;
  accessPatternStat: any;
  unitId: string;

  public get age(): number {
    return this.birthDate ? Users.ageCalculator(this.birthDate) : 0;
  }

  public get joinNow(): string {
    return this.joinDate ? Dates.fromNow(this.joinDate) : "";
  }

  constructor(user?: any) {
    const model = user || {};

    Object.assign(this, model);

    this.created = model.created ? new Date(model.created) : null;
    this.modified = model.modified ? new Date(model.modified) : null;
    this.joinDate = model.joinDate ? new Date(model.joinDate) : null;
    this.birthDate = model.birthDate ? new Date(model.birthDate) : null;
  }

  public isChange(other: User): boolean {
    return this.name != other.name ||
      this.email != other.email || 
      !Dates.equals(this.birthDate, other.birthDate) ||
      !Dates.equals(this.joinDate, other.joinDate) ||
      this.state != other.state ||
      this.companyId != other.companyId ||
      this.gender != other.gender ||
      this.jobTitle != other.jobTitle ||
      this.photo != other.photo ||
      this.phoneNumber != other.phoneNumber;
  }

  public toDisplayName(includeEmail: boolean = false, includeCompany: boolean = false): string {
    return `${includeCompany ? ('[' + (this.company?.name || 'Unkown Group') + '] ') : ''}${this.name}${this.jobTitle ? (' (' + this.jobTitle + ')') : ''}${includeEmail ? ', ' + this.email : ''}`;
  }

  public get displayName(): string {
    return `${this.name}${this.jobTitle ? (' (' + this.jobTitle + ')') : ''}`;
  }
}
